import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { RootState } from '@Root/slices'
import {
  fetchSamePtpArticleList,
  fetchSimilarPtpArticleList,
  samePtpArticleParam,
  similarPtpArticleParam,
  resetSamePtpArticle,
  resetSimilarPtpArticle,
} from '@Root/slices/myhouse/article'

export default function usePtpArticle() {
  const dispatch = useDispatch()
  const ptpArticle = useSelector((state: RootState) => state.ptpArticle)

  const loadSamePtpArticle = useCallback(
    (param: samePtpArticleParam) => {
      dispatch(fetchSamePtpArticleList(param))
    },
    [dispatch],
  )

  const loadSimilarPtpArticle = useCallback(
    (param: similarPtpArticleParam) => {
      dispatch(fetchSimilarPtpArticleList(param))
    },
    [dispatch],
  )

  const setSamePtpArticle = useCallback(() => {
    dispatch(resetSamePtpArticle())
  }, [dispatch])

  const setSimilarPtpArticle = useCallback(() => {
    dispatch(resetSimilarPtpArticle())
  }, [dispatch])

  return { ptpArticle, loadSamePtpArticle, loadSimilarPtpArticle, setSamePtpArticle, setSimilarPtpArticle }
}
